<template>
    <div class="FileUploadAndDispatch">
        <div class="container-fluid">
            <div class="row">
                <div class="col paper" style="text-align:end;">
                    <Logout />
                    <h3 class="center-text"><font-awesome-icon :icon="['fa', 'lock']" /> Olive Crest Secure File Upload</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-md paper">
                    <h4 class="center-text">Send File to Group</h4>
                    <div class="row" v-for="group in Groups">
                        <div class="col">
                            <p @click="OpenGroupSendModal(group)" class="link-like">{{ group.Label }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-md paper">
                    <h4 class="center-text">My Recent Uploads</h4>
                    <div class="row" v-for="recentUpload in RecentUploads">
                        <div class="col">
                            <p><a :href="recentUpload.Link" target="_blank">{{ formatDate(recentUpload.UploadDateLocal)}}: {{recentUpload.GroupLabel}} ({{ recentUpload.FileName }})</a></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="whitetext">NOTICE: This system contains privileged and/or confidential information for the sole use of the intended recipient. Any review, use, distribution or disclosure by others is strictly prohibited. If you are not the intended recipient and/or not an authorized user of this system, please log out immediately and delete all copies of information obtained from this system.</p>
                    <p class="whitetext">&copy; 2024 - Olive Crest</p>
                </div>
            </div>
        </div>

        <!--CREATE NEW APPOINTMENT-->
        <b-modal ref="modal-upload" size="lg" :title="SelectedGroup.Label" hide-footer>
            <b-container>
                <b-form @submit="UploadFile" ref="upload-form">
                    <b-row>
                        <b-col>
                            <input type="hidden" name="UploadGroupID" v-model="SelectedGroup.Id" />
                            <div class="form-group">
                                <label>File:</label>
                                <b-form-file class="form-control"
                                             name="FormFile"
                                             required
                                             drop-placeholder="Drop file here..."></b-form-file>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Message (optional):</label>
                                <textarea class="form-control" rows="4" name="Message"></textarea>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelGroupSendModal()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                UPLOAD
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    import { EventBus } from '../../services/event-bus.js';
    import Logout from '../Core/UI/Logout.vue';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faLock } from '@fortawesome/free-solid-svg-icons';
    library.add(faLock);
    import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
    library.add(faCaretDown);
    import { faEye } from '@fortawesome/free-solid-svg-icons';
    library.add(faEye);
    import { faEyeSlash } from '@fortawesome/free-solid-svg-icons';
    library.add(faEyeSlash);

    export default {
        created() {

        },
        beforeDestroy() {
            
        },
        props: [],
        data: function () {
            return {
                Groups: [],
                RecentUploads: [],
                SelectedGroup: ""
            };
        },
        methods: {
            GetGroups() {
                this.$MasterAPI.ExecuteRequest("GET", "UserUtilities/FileUploadAndDispatchFiles/Groups/GetUploadable", {}, this.GetGroupsSuccess,()=>{}, true);
            },
            GetGroupsSuccess(response) {
                this.Groups = response.data.data;
            },
            GetRecentUploads() {
                this.$MasterAPI.ExecuteRequest("GET", "UserUtilities/FileUploadAndDispatchFiles/FileUpload/GetMyRecentUploads", {}, this.GetRecentUploadsSuccess, () => { }, true);
            },
            GetRecentUploadsSuccess(response) {
                this.RecentUploads = response.data.data;
            },
            OpenGroupSendModal(group) {
                this.SelectedGroup = group;
                this.$refs["modal-upload"].show();
            },
            CancelGroupSendModal() {
                this.$refs["modal-upload"].hide();
            },
            UploadFile(e) {
                e.preventDefault();
                let form = this.$refs['upload-form'];
                let formData = new FormData(form);

                this.$MasterAPI.ExecuteRequest("POST", "UserUtilities/FileUploadAndDispatchFiles/FileUpload", formData, this.UploadFileSuccess, () => { }, true);
            },
            UploadFileSuccess(response) {
                this.GetRecentUploads()

                this.$refs["modal-upload"].hide();
            },
            formatDate (value, fmt = 'MM/DD/YY', defaultVal = '') {
              return (value == null)
                ? defaultVal
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
        },
        components: {
            Logout
        },
        computed: {

        },
        mounted() {
            this.GetGroups();
            this.GetRecentUploads();
        }
    }
</script>

<style scoped>
    .FileUploadAndDispatch {
        background-color: #605271;
    }
</style>